import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ className, size = 'default', ...props }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    default: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  return (
    <Loader2 
      className={cn(
        'animate-spin text-slate-900',
        sizeClasses[size],
        className
      )} 
      {...props} 
    />
  );
};

const LoadingScreen = ({ message = 'Loading...', className, fullScreen = true }) => {
  return (
    <div className={cn(
      'flex flex-col items-center justify-center space-y-6 bg-white',
      fullScreen ? 'min-h-[80vh] w-full' : 'min-h-[200px] w-full',
      className
    )}>
      <div className="relative">
        <div className="absolute inset-0 bg-slate-100 rounded-full animate-ping opacity-75"></div>
        <div className="relative bg-white rounded-full p-4 shadow-xl shadow-slate-100 border border-slate-50">
          <LoadingSpinner size="lg" className="text-slate-900" />
        </div>
      </div>
      
      <div className="text-center space-y-2">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-[0.2em] animate-pulse">
          {message}
        </p>
      </div>
    </div>
  );
};

export { LoadingSpinner, LoadingScreen };